/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateScreeningMetricItemDto } from './create-screening-metric-item-dto';
import { ScreeningExerciseDto } from './screening-exercise-dto';
 /**
 *
 *
 * @export
 * @interface CreateScreeningMetricsDto
 */
export interface CreateScreeningMetricsDto {

    /**
     * Correlates every item across every call belonging to one test attempt. Generated once by Unity when the attempt starts, sent unchanged on each request for that attempt, discarded when the attempt ends.
     *
     * @type {string}
     * @memberof CreateScreeningMetricsDto
     */
    attemptId: string;

    /**
     * Exercise context shared across all items — the test Unity is running. Omit or send null for unweighted tests with no exercise context. Server always writes id: null (no catalog row backs a screening test).
     *
     * @type {ScreeningExerciseDto}
     * @memberof CreateScreeningMetricsDto
     */
    exercise?: ScreeningExerciseDto | null;

    /**
     * One item per measurement. ROM items carry the angle; VAS items carry the pain score with a timepoint. Bilateral tests send both sides in one request with a different district+side per item.
     *
     * @type {Array<CreateScreeningMetricItemDto>}
     * @memberof CreateScreeningMetricsDto
     */
    items: Array<CreateScreeningMetricItemDto>;
}
